import React, { useEffect, useState, useRef } from "react";
import { Popup, Input, List, Loading } from 'react-vant';
import './birthplacePop.scss';
import { httpUrl } from '../../utils/apiService';
import axios from 'axios';
import right from '../../assets/update_new/arrow_right.svg'

// 城市搜索防抖定时器
let cityDebounceTimeout = null;

const BirthplacePop = ({ birthplaceStatus,clickBirthplaceStatus,countryCallback,cityCallback,latCallback,longCallback }) => {
    const [birthplacePop, setBirthplacePop] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState('');
    const [showSearchData, setShowSearchData] = useState(false);
    const [cityLoading, setCityLoading] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState('');
    const [cityList, setCityList] = useState([]);
    const [cityData, setCityData] = useState({});
    const [city, setCity] = useState('');
    const [lat, setLat] = useState('');
    const [long, setLong] = useState('');
    const [searchData, setSearchData] = useState([]);
    const [isTab, setIsTab] = useState('1');
    const cityListRef = useRef(null);
    const searchListRef = useRef(null);

    useEffect(() => {
        setBirthplacePop(birthplaceStatus);
    }, [birthplaceStatus]);

    useEffect(() => {
        getCountry();
    }, []);

    // 城市选择一系列
    const searchChange = (e) => {
        setSearchInputValue(e);
        // 清除之前的定时器
        if (cityDebounceTimeout) {
            clearTimeout(cityDebounceTimeout);
        }
        cityDebounceTimeout = setTimeout(() => {
            if (e.trim().length >= 2) {
                getSearchResult(e);
                setShowSearchData(true);
                setCityLoading(true);
            } else if (e.trim().length === 0) {
                setShowSearchData(false);
            }
        }, 500);
    };

    const changeCountry = (value) => {
        setCountry(value);
        setIsTab('2');
        setCityLoading(true);
        getCity(value);

        countryCallback(value); // 回调给父组件
    };

    const changeCity = (index) => {
        if (cityData[index]) {
            setCity(cityData[index].city);
            setLat(cityData[index].lat);
            setLong(cityData[index].long);
            setIsTab('1');
            //setBirthplacePop(false);
            clickBirthplaceStatus(false);

            cityCallback(cityData[index].city); // 回调给父组件
            latCallback(cityData[index].lat); // 回调给父组件
            longCallback(cityData[index].long); // 回调给父组件
        }
    };

    const changeSearchValue = (index) => {
        if (searchData[index]) {
            setCountry(searchData[index].country);
            setCity(searchData[index].city);
            setLat(searchData[index].lat);
            setLong(searchData[index].long);
            setShowSearchData(false);
            setIsTab('1');
            //setBirthplacePop(false);
            clickBirthplaceStatus(false);
            setSearchInputValue('');

            countryCallback(searchData[index].country); // 回调给父组件
            cityCallback(searchData[index].city); // 回调给父组件
            latCallback(searchData[index].lat); // 回调给父组件
            longCallback(searchData[index].long); // 回调给父组件
        }
    };

    const getCity = (value) => {
        axios.get(`${httpUrl}/api/get_city`, { params: { country: value } })
            .then(response => {
                setCityList(response.data.data.map(item => item.city));
                setCityData(response.data.data);
                setCityLoading(false);
            })
            .catch(error => {
                console.error(error);
            });
    };

    useEffect(() => {
        if (cityListRef.current) {
            cityListRef.current.scrollTop = 0;
        }
    }, [cityList]);

    useEffect(() => {
        if (searchListRef.current) {
            searchListRef.current.scrollTop = 0;
        }
    }, [searchData]);

    const getCountry = () => {
        axios.get(`${httpUrl}/api/get_country`)
            .then(response => {
                setCountryList(response.data.data);
            })
            .catch(error => {
                console.error(error);
            });
    };

    const getSearchResult = (searchInputValue) => {
        axios.get(`${httpUrl}/api/get_country_city_and_like`, { params: { content: searchInputValue } })
            .then(response => {
                setSearchData(response.data.data);
                setCityLoading(false);
            })
            .catch(error => {
                console.error(error);
            });
    };

    return (
        <Popup
            visible={birthplacePop}
            closeable
            className="birthplace_"
            position='bottom'
            round
            closeOnClickOverlay={true}
            onClose={() => clickBirthplaceStatus(false)}
        >
            <div className="birthplace_box_">
                <span className="birthplace_box_title">Birthplace</span>
                <Input
                    placeholder="Search your country/region"
                    value={searchInputValue}
                    onChange={searchChange}
                    clearable
                    clearTrigger="always"
                />
                <div className="birthplace_tab" style={showSearchData ? { display: 'none' } : { display: 'flex' }}>
                    <span className={`birthplace_tab_text ${isTab === '1' ? 'active' : ''}`} onClick={() => setIsTab('1')}>
                        {country ? country : 'Country'}
                    </span>
                    {(isTab === '2' || cityData.length > 0) && (
                        <>
                            <span className='birthplace_tab_diver'></span>
                            <span className={`birthplace_tab_text ${isTab === '2' ? 'active' : ''}`} onClick={() => setIsTab('2')}>
                                {city ? city : 'City'}
                            </span>
                        </>
                    )}
                </div>
                <div className="country_list" style={showSearchData ? { display: 'none' } : { display: 'flex' }}>
                    <div className="country_list_box_list" style={isTab === '1' ? { display: 'flex' } : { display: 'none' }}>
                        <List
                            height={500}
                            itemCount={countryList.length}
                            itemSize={50}
                            width="90%"
                            style={{ scrollbarWidth: 'none' }}>
                            {countryList.map((_, index) => (
                                <div key={index} className="country_list_box" onClick={() => changeCountry(_)}>
                                    <span className="country_list_text">{_}</span>
                                    <img
                                        style={{ width: '6px', height: '11px' }}
                                        src={right}
                                    />
                                </div>
                            ))}
                        </List>
                    </div>
                    <div className="city_list_box_list" style={isTab === '1' ? { display: 'none' } : { display: 'flex' }}>
                        <List
                            height={500}
                            itemCount={cityList.length}
                            itemSize={50}
                            width="90%"
                            ref={cityListRef}
                            style={cityLoading ? { display: 'none' } : { display: 'block', scrollbarWidth: 'none' }}
                        >
                            {cityList.map((value, index) => (
                                <div key={index} className="city_list_box" onClick={() => changeCity(index)}>
                                    <span className="city_list_text">{value}</span>
                                    <img
                                        style={{ width: '6px', height: '11px' }}
                                        src={right}
                                    />
                                </div>
                            ))}
                        </List>
                        <div style={cityLoading ? { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } : { display: 'none' }}>
                            <Loading color="#EAA95A" />
                        </div>
                    </div>
                </div>
                <div className="search_list" style={showSearchData ? { display: 'flex' } : { display: 'none' }}>
                    <div className="search_list_box_list">
                        <List
                            height={500}
                            itemCount={searchData.length}
                            itemSize={50}
                            width="90%"
                            ref={searchListRef}
                            style={cityLoading ? { display: 'none' } : { display: 'block', scrollbarWidth: 'none' }}
                        >
                            {searchData.map((value, index) => (
                                <div key={index} className="search_list_box" onClick={() => changeSearchValue(index)}>
                                    <span className="search_list_text">{value.city + " " + value.country}</span>
                                    <img
                                        style={{ width: '6px', height: '11px' }}
                                        src={right}
                                    />
                                </div>
                            ))}
                        </List>
                        <div style={cityLoading ? { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } : { display: 'none' }}>
                            <Loading color="#EAA95A" />
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};
export default BirthplacePop;